// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  DATE_RANGE_SHORTCUT_LAST_30_DAYS,
  DATE_RANGE_SHORTCUT_LAST_60_DAYS,
  DATE_RANGE_SHORTCUT_LAST_90_DAYS,
  DATE_RANGE_SHORTCUT_LAST_180_DAYS,
  DATE_RANGE_SHORTCUT_LAST_365_DAYS,
  DATE_RANGE_SHORTCUT_LAST_FULL_MONTH,
  DATE_RANGE_SHORTCUT_LAST_MONTH_TO_DATE,
  DATE_RANGE_SHORTCUT_THIS_MONTH,
  DateRangeShortcut,
} from '@/constants/date-range-shortcut';

export const ASSET_PRESENCE_REPORT_MAX_DAYS = 365;

export const ASSET_PRESENCE_REPORT_DATE_RANGE_SHORTCUTS: DateRangeShortcut[] = [
  DATE_RANGE_SHORTCUT_THIS_MONTH,
  DATE_RANGE_SHORTCUT_LAST_MONTH_TO_DATE,
  DATE_RANGE_SHORTCUT_LAST_FULL_MONTH,
  DATE_RANGE_SHORTCUT_LAST_30_DAYS,
  DATE_RANGE_SHORTCUT_LAST_60_DAYS,
  DATE_RANGE_SHORTCUT_LAST_90_DAYS,
  DATE_RANGE_SHORTCUT_LAST_180_DAYS,
  DATE_RANGE_SHORTCUT_LAST_365_DAYS,
];
